"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShouldExpose = exports.makeExposureRequest = void 0;
var tslib_1 = require("tslib");
var track_exposure_response_1 = require("../bi/track-exposure-response");
var experiments_bag_utils_1 = require("./experiments-bag.utils");
function makeExposureRequest(exposureService, getBiDefaultParams, showOptions) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var exposurePayload, shouldExpose, categoryId, unExposedReason, biDefaultParams;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (showOptions.disableExposure) {
                        return [2 /*return*/, {
                                shouldExpose: true,
                            }];
                    }
                    return [4 /*yield*/, exposureService.getShouldAskQuestion(showOptions.questionId)];
                case 1:
                    exposurePayload = _a.sent();
                    shouldExpose = exposurePayload.shouldExpose, categoryId = exposurePayload.categoryId, unExposedReason = exposurePayload.unExposedReason;
                    biDefaultParams = getBiDefaultParams(categoryId);
                    track_exposure_response_1.trackExposureResponse(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, biDefaultParams), { isAllowed: shouldExpose }), (!shouldExpose ? { blockReason: unExposedReason } : {})));
                    return [2 /*return*/, exposurePayload];
            }
        });
    });
}
exports.makeExposureRequest = makeExposureRequest;
function getShouldExpose(exposureRequest, experiments) {
    if (experiments_bag_utils_1.isExperimentEnabled(experiments, 'specs.user-feedback.DisableExposure')) {
        return Promise.resolve({
            shouldExpose: true,
        });
    }
    return exposureRequest;
}
exports.getShouldExpose = getShouldExpose;
//# sourceMappingURL=should-expose.js.map